module.exports = __webpack_public_path__ + "dlssrvtyy/img/thai_slider-2.jpg?8b851e05";